<template>
  <!--  正在审批的页面 -->
  <div class="approved_box pack_box">
    <ax-result-page
      v-if="showResult"
      type="network"
      subtext="要不然下拉刷新试试？"
    ></ax-result-page>
    <div v-if="!showResult && showContent">
      <div class="number">单号：{{ instanceId }}</div>
      <ax-head>
        <div
          slot="ing"
          v-if="action"
        >
        <p>
            来自{{ pageId==='specialEntry'?data.other.originator_dept_descr: data.header.dept_descr || data.header.deptid_description }}的{{ pageId==='specialEntry'?data.header.originatorid_description:'' }}
            <em>{{ pageId==='backgroundCheck'?data.header.name_display:data.header.emplid_description  }}</em>{{pageId==='offer'||pageId==='rehire'?'':'的'}}
            <em>{{ pageObj.title }}{{data.header.qh_total_days ? data.header.qh_total_days + '天': ''}}{{pageId==='offer'||pageId==='rehire'?'':'申请'}}</em>，请您审批。
          </p>
        </div>
        <div
          slot="over"
          v-else-if="actionNone"
        >
          <p>请重试</p>
        </div>
        <div
          slot="over"
          v-else
        >
          <p>{{getWfStatusDesc(data.header.wf_status)}}</p>
        </div>
      </ax-head>
      <!-- 表单内容 -->
      <upcomingDetailComponent
        ref="inner"
        v-if="pageId && data"
        :data="decryptData || data"
        :options="pageObj.options || {}"
        :pageObj="pageObj || {}"
        :comments="comments || ''"
        @reciveData="reciveData"
        @saveSubData="saveSubData"
        @getLeaveData="getLeaveData"
        @getBcomeData="getBcomeData"
        @OutsourcingDimissionData="OutsourcingDimissionData"
      ></upcomingDetailComponent>
      <div v-if="action&&showButton">
        <ax-panel
          title="审批意见"
          :noBorder="true"
        >
          <textarea
            class="comments_box"
            rows="5"
            v-model="comments"
            placeholder="请输入您的审批意见"
          ></textarea>
        </ax-panel>
        <p
          v-if="pageId === 'offer'"
          style="margin:0.5rem 0.5rem;color:rgba(0, 0, 0, 0.3);font-size:0.36rem"
        >
          *如需查询，附件、面试评价等详细信息，请移步PC端进行审批
        </p>
        <p
          v-if="pageId === 'changeSign'"
          style="margin:0.5rem 0.5rem;color:rgba(0, 0, 0, 0.3);font-size:0.36rem"
        >
          *如需查看附件或要上传审批相关文件，请移步PC端进行审批
        </p>
        <p
          v-if="pageId === 'transfer'"
          style="margin:0.5rem 0.5rem;color:rgba(0, 0, 0, 0.3);font-size:0.36rem"
        >
          *如需查看更多信息或要上传审批相关文件，请移步PC端进行审批
        </p>
        <div class="handle_box">
          <a
            class="reject"
            href="javascript:;"
            @click="handleApproval(-1)"
          >拒绝</a>
          <a
            class="approve"
            href="javascript:;"
            @click="handleApproval(1)"
          >同意</a>
        </div>
      </div>
      <suspend-button v-if="ownApprovalFlag" @click="recordJump">审批<br/>记录</suspend-button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import request from '@/utils/request';
import upcomingObj from '@/assets/js/approval/upComDetail.js';
import doNext from '@/mixins/doNext';
export default {
  data() {
    return {
      pageId: null,
      pageObj: {},
      version: this.$route.query.version || 0.0,
      apply: this.$route.query.apply,
      action: true, // 是否可审批
      actionNone: false, // 没拿到action值为false
      showResult: false,
      showContent: true,
      instanceId: this.$route.query.instanceId,
      data: {
        header: {},
        other: {}
      },
      decryptData: null,
      // data:null,
      toast: null,
      comments: '',
      subData: {},
      leaveData: {},
      path: '',
      innerAction: true,
      becomeData: {},
      becomeFlag: false,
      showButton: false,
       // 判断显示隐藏提示
      isAgrees: 0,
      //BP修改的字段
      qh_ter_act_reason:'',
      qh_ter_act_reason_description:'',
      isHRBPs:''
    };
  },
  mixins: [doNext],
  watch: {
    $route() {
      this.getPageId();
      this.fetchDataByPageId();
    }
  },

  created() {
    this.toast = this.$toast.loading({
      mask: false,
      message: '加载中...',
      duration: 0
    });
    this.getPageId();
    this.fetchDataByPageId();
  },
  methods: {
    // 接收 解密后的数据
    reciveData(data) {
      this.data = data;
      if (this.data.action) {
        this.action = this.data.action === 'U'; // U 可以审批 V 只能查看
      } else {
        this.actionNone = true;
      }
      // console.log('this.actionNone', this.actionNone,this.action);
    },

    // 获取pageId
    getPageId() {
      this.instanceId = this.$route.query.instanceId;
      this.version = this.$route.query.version || 0.0;
      if (Object.prototype.toString.call(this.version) === '[object Array]') {
        this.version = this.version[1] ? this.version[1] : this.version;
      }
      this.pageId = this.$route.query.pageId;
      this.pageObj = upcomingObj[this.pageId] || {};
      this.path = this.pageObj.path || '';
      Vue.component('upcomingDetailComponent', this.pageObj['component']);
      this.$setIosTitle(this.pageObj.title || '审批详情');
    },
    // 根绝pageId 获取数据
    fetchDataByPageId() {
      if (!this.pageObj) {
        this.showResult = true;
        return;
      }
      let options = {
        url: this.pageObj.serviceUrl,
        method: this.pageObj.method
      };
      let body = {};
      if (this.pageObj.data) {
        this.pageObj.data.forEach((item) => {
          body[item[0]] = this[item[1]];
        });
      }
      if (this.pageObj.method === 'get') {
        options.params = body;
      } else {
        options.data = body;
      }
      request(options)
        .then(({ data }) => {
          console.log('fetchDataByPageId==', data);
          if (data.code === 200) {
            this.showResult = false;
            this.showButton = true;
            this.showContent = true;
            if (typeof data.data == 'object') {
              this.data = data.data;
              this.action = this.data.action === 'U'; // U 可以审批 V 只能查看
            } else {
              this.decryptData = data.data;
            }
          } else {
            this.showResult = true;
          }
        })
        .catch((e) => {
          this.showResult = true;
        })
        .finally(() => {
          this.toast && this.toast.clear();
        });
    },
    // 回填的数据
    saveSubData(obj) {
      this.subData = obj;
    },
    // 转正审批回填的数据
    getBcomeData(obj, flag) {
      this.becomeData = obj;
      this.becomeFlag = flag;
    },
    // 离职审批回填的数据
    getLeaveData(obj, action) {
      this.leaveData = obj;
      this.innerAction = action;
    },
       // 外包离职审批
    OutsourcingDimissionData(obj) {
      // console.log('num', obj)
      this.isHRBPs = obj.isHRBP
      if(obj.isHRBP =='MANAGER'){
        this.isAgrees = obj.isAgree
      }else if(obj.isHRBP =='HRBP'){
        this.qh_ter_act_reason = obj.terType
        this.qh_ter_act_reason_description = obj.terDescr
      }
    },
    getEmpty(obj) {
      // 离职欢送会字段不可见
      if (!this.data.field_special_deal.qh_is_hsp_visible) {
        delete obj.qh_is_hsp;
      }
      // 是否审计不可见
      if (!['M5','M6','M7','M8','M9','M10','S11','S12','S13','S14'].includes(this.data.header.qh_cj_code_description)){
        delete obj.check_char;
      }
      for (let k in obj) {
        // 邮件转发是  否
        if (k === 'qh_check_wrok_tsf' && obj[k] === 'N') {
          delete obj.qh_work_trsfer_id;
          delete obj.qh_work_trsfer_dt;
          delete obj.qh_work_tsf_end_dt;
        }
      }
      for (let key in obj) {
        if (!obj[key]) {
          return key;
        }
      }
      return '';
    },
    getEmptyMessage(key) {
      switch (key) {
        case 'last_date_worked':
          return '请选择最后的工作日期';
          break;
        case 'checked':
          return '请选择是否竞业';
          break;
        case 'check_char':
          return '请选择是否进行离任审计';
          break;
        case 'checklist_btn':
          return '请选择团队申明';
          break;
        case 'qh_check_wrok_tsf':
          return '请选择是否邮件转发';
          break;
        case 'qh_work_trsfer_id':
          return '请选择承接人编码';
          break;
        case 'qh_work_trsfer_dt':
          return '请选择承接转发开始日期';
          break;
        case 'qh_work_tsf_end_dt':
          return '请选择承接结束日期';
          break;
        case 'qh_is_hsp':
          return '请选择是否组织离职联欢会';
          break;
      }
    },
    // 审批
    handleApproval(item) {
      let originItem = item
      let name = item === 1 ? '同意' : '拒绝',
        // query = {
        //   "jumpType": item === 1?'AGREE':'BACK_TO_STARTOR',
        //   "instId": this.instanceId,
        //   "version": this.version,
        //   "platform": "ehr",
        //   "path": this.path || this.pageId,
        //   "emplid": this.data.header.emplid,
        //   "action_dt_ss": this.data.header.action_dt_ss,
        //   "effseq": this.data.header.effseq,
        //   "comments": this.comments,
        // };
        query = {
          jumpType: item === 1 ? 'AGREE' : 'BACK_TO_STARTOR',
          instId: this.instanceId,
          version: this.version,
          platform: 'ehr',
          opinion: this.comments,
          jsonData: {
            service_type: this.path || this.pageId,
            emplid: this.data.header.emplid,
            empl_rcd: this.data.header.empl_rcd,
            action_dt_ss: this.data.header.action_dt_ss,
            effseq: this.data.header.effseq,
            comments: this.comments
          },
          extJsonData: ''
        };
      // 合同签约
      if (this.pageId === 'renewal') {
        let empl_class = this.data.header.empl_class;
        let current_oprid = this.data.current_oprid;
        let oprid = this.data.header.emplid;
        let max_step_nbr = this.data.max_step_nbr; // 最大审批步骤号
        let current_step_nbr = this.data.pending_step_instance[0]
          ? this.data.pending_step_instance[0].step_nbr
          : ''; // 当前节点
        let isSelf = current_oprid === oprid;
        //　劳务 和 实习生
        if (
          !isSelf &&
          !this.subData.qh_contract_yes &&
          (empl_class === '03' || empl_class === '04')
        ) {
          this.toast = this.$toast({
            message: '请您选择审批类型',
            duration: 1500
          });
          return;
        }
        // 普通实习生 续签的时候 需要附件
        if (
          !isSelf &&this.subData.qh_contract_yes === 'C' &&!this.subData.filename
        ) {
          this.toast = this.$toast({
            message: '请您选择附件',
            duration: 1500
          });
          return;
        }

        query.jsonData.qh_hr_019_wk = {
          comments: this.comments,
          qh_contract_yes: this.subData.qh_contract_yes
            ? this.subData.qh_contract_yes
            : item === 1
            ? 'Y'
            : 'N'
        };
        query.jsonData.qh_hr_019_atta = [{ ...this.subData }];

        // 正式 、 派遣正式、 校招实习生 、 暑期实习生  ， 在HR 和 直接上级领导审批时  审批拒绝时要调审批通过接口， 流程可以往下走
        let isTransferToApproval =
          empl_class === '01' ||
          empl_class === '02' ||
          empl_class === '05' ||
          empl_class === '06' ||
          empl_class === '08';
        if (isTransferToApproval && current_step_nbr < max_step_nbr) {
          query.jumpType = 'AGREE';
          item = 1;
        }

        // 不是本人  审批意见为必填
        if (!isSelf && !this.comments) {
          this.toast = this.$toast({
            message: '请您输入审批意见',
            duration: 1500
          });
          return false;
        }
        // 续签提示
        // 是否需要提示（是否最后一个节点）Y为是,N为否
        if(this.data.lastStepFlag == 'Y') {
          // noticeType，提示类型：
          // A前面所有人都同意了，拒绝时提示
          // D代表所有人都拒绝了，同意时提示
          // B代表前面的人有同意的有拒绝的，两个按钮都要提示
          // item === 1 ? '同意' : '拒绝'
          if((this.data.noticeType === 'A' && originItem === -1) || (this.data.noticeType === 'D' && originItem === 1) || (this.data.noticeType === 'B')) {
            query.jsonData = JSON.stringify(query.jsonData);
            this.$dialog
            .confirm({
              title: '提示',
              message: '注意：前置审批人意见有不一致，如已线下达成一致，请点击确认',
              beforeClose: (action, done) => {
                if (action === 'confirm') {
                  this.handleDoNext(query, '审批成功', done)
                } else {
                  done();
                }
              }
            })
            .catch(() => {});

            return false;
          }
        }
      }
      // 离职审批leaveOffice
      if (this.pageId === 'leaveOffice') {
        this.$refs.inner.returnLeaveData();
        console.log('leaveData', this.leaveData, this.innerAction);
        // 上级有没输入的审批意见提示
        if (this.innerAction && item === 1) {
          const empty = this.getEmpty(this.leaveData);
          if (empty !== '') {
            this.toast && this.toast.clear();
            this.toast = this.$toast({
              message: this.getEmptyMessage(empty),
              duration: 1500
            });
            return false;
          }
        } else {
          const lhcAction =
            this.data.field_special_deal.qh_is_hsp_visible &&
            this.data.field_special_deal.qh_is_hsp_enabled;
          if (lhcAction && this.leaveData.qh_is_hsp === '' && item === 1) {
            this.toast && this.toast.clear();
            this.toast = this.$toast({
              message: '请选择是否组织离职联欢会',
              duration: 1500
            });
            return false;
          }
        }
        query.jsonData.qh_hr_011_head = this.leaveData;
      }
           // 外包离场流程
      if (this.pageId === 'outsourcingDimission') {
        this.$refs.inner.returnOutsourcingDimissionData();
        if(this.isHRBPs =='MANAGER'&&item === 1){
          if(this.isAgrees>0){
            this.toast = this.$toast({
              message: '该员工有在途考勤流程未完成，需请相关审批人处理完毕后再批准离职',
              duration: 1500
            });
            return false;
          }
        }else if(this.isHRBPs =='HRBP'){
          query.jsonData.qh_hr_027_head = 
          {
            qh_ter_act_reason:this.qh_ter_act_reason,
            // qh_ter_act_reason_description:this.qh_ter_act_reason_description
          }
        }
        // return
      }
      // 被动离职passiveResignation
      if (this.pageId === 'passiveResignation') {
        this.$refs.inner.returnLeaveData();
        const ifAdjust =this.innerAction
        console.log('ifAdjust', ifAdjust);
        if (this.data.field_special_deal.qh_fixed_pay_enabled) {
          query.jsonData.qh_fixed_pay = this.data.header.qh_fixed_pay
        }
        if(ifAdjust=='Y'){
          if (!this.data.header.qh_wa_pay_041) {
            this.toast && this.toast.clear();
            this.toast = this.$toast({
              message: '请您输入调整金额',
              duration: 1500
            });
            return false;
          }
          if (this.data.header.qh_wa_pay_041 < 0) {
            this.toast && this.toast.clear();
            this.toast = this.$toast({
              message: '调整金额不得小于0',
              duration: 1500
            });
            return false;
          }
          if (!this.data.header.qh_actn_reason_254) {
            this.toast && this.toast.clear();
            this.toast = this.$toast({
              message: '请您输入调整说明',
              duration: 1500
            });
            return false;
          }
          query.jsonData.qh_wa_pay_041 = this.data.header.qh_wa_pay_041
          query.jsonData.qh_actn_reason_254 = this.data.header.qh_actn_reason_254
        }
      }
      // 转正审批becomeRegular
      if (this.pageId === 'becomeRegular') {
        let max_step_nbr = this.data.max_step_nbr; // 最大审批步骤号
        let current_step_nbr = this.data.pending_step_instance[0]
          ? this.data.pending_step_instance[0].step_nbr
          : ''; // 当前节点
        query.jsonData.qh_hr_002_wrk = {
          comments: this.comments,
          qh_yes: item === 1 ? 'Y' : 'N'
        };
        if (current_step_nbr < max_step_nbr) {
          query.jumpType = 'AGREE';
          item = 1;
        }
        this.$refs.inner.returnBecomeData(item);
        console.log('becomeData', this.becomeData, this.becomeFlag);
        // 上级有没输入的审批意见提示
        if (!this.becomeFlag && item === 1) return false;
        if (!this.comments) {
          this.toast && this.toast.clear();
          this.toast = this.$toast({
            message: '请您输入审批意见',
            duration: 1500
          });
          return false;
        }
        query.jsonData.qh_hr_002_apprv = this.becomeData;
        // 转正提示
        // 是否需要提示（是否最后一个节点）Y为是,N为否
        if(this.data.lastStepFlag == 'Y') {
          // noticeType，提示类型：
          // A前面所有人都同意了，拒绝时提示
          // D代表所有人都拒绝了，同意时提示
          // B代表前面的人有同意的有拒绝的，两个按钮都要提示
          // item === 1 ? '同意' : '拒绝'
          if((this.data.noticeType === 'A' && originItem === -1) || (this.data.noticeType === 'D' && originItem === 1) || (this.data.noticeType === 'B')) {
            query.jsonData = JSON.stringify(query.jsonData);
            this.$dialog
            .confirm({
              title: '提示',
              message: '注意：前置审批人意见有不一致，如已线下达成一致，请点击确认',
              beforeClose: (action, done) => {
                if (action === 'confirm') {
                  this.handleDoNext(query, '审批成功', done)
                } else {
                  done();
                }
              }
            })
            .catch(() => {});

            return false;
          }
        }
      }
      // 转岗必填意见
      if (this.pageId === 'transfer' && !this.comments) {
        this.toast && this.toast.clear();
        this.toast = this.$toast({
          message: '请您输入审批意见',
          duration: 1500
        });
        return false;
      }
      // 重新雇佣
      if (this.pageId === 'rehire') {
        let reh_result = this.data.reh_result
        if (!reh_result) {
          this.toast && this.toast.clear();
          this.toast = this.$toast({
            message: '请您选择审批意见',
            duration: 1500
          });
          return false;
        }
        query.jsonData.reh_result = reh_result;
        if (item === 1 && reh_result != 'A' && !this.comments) {
          this.toast && this.toast.clear();
          this.toast = this.$toast({
            message: '请您输入审批意见',
            duration: 1500
          });
          return false;
        }
      }
      // if (this.version <= 1.0) {
      //   this.checkVersion();
      //   return false;
      // }
      if (item === -1 && !this.comments) {
        this.toast && this.toast.clear();
        this.toast = this.$toast({
          message: '请您输入审批意见',
          duration: 1500
        });
        return false;
      }

      query.jsonData = JSON.stringify(query.jsonData);

      this.$dialog
        .confirm({
          title: '提示',
          message: '确定执行' + name + '操作?',
          beforeClose: (action, done) => {
            if (action === 'confirm') {
              this.handleDoNext(query, '审批成功', done)
            } else {
              done();
            }
          }
        })
        .catch(() => {});
    },
    // 获取审批状态
    getWfStatusDesc(status){
      switch (status) {
        case 'C':
          return '已撤回'
        default:
          return '您已审批'
      }
    },
    // 跳转到审批记录
    recordJump() {
      this.$router.push({
        path: '/upcoming/record',
        query: {
          instanceId: this.instanceId,
          pageId: this.pageId
        }
      })
    }
  },
  beforeDestroy() {
    this.toast && this.toast.clear();
  }
};
</script>
